import axios from 'axios';
import { prepareDateTimeForHttpRequest } from 'helpers/dateHelper';
import { Slip } from 'types/Slip';
import { UserInfo } from 'types/UserInfo';
import { mapHttpResponse } from 'utils/slip.utils';

export interface AccountStatementRow {
  id: number;
  timestamp: string;
  transaction_type: string;
  casino_game_name?: string;
  amount: number;
  total_balance: number;
  ticket_id: number | null;
}

export interface AccountStatementResponse {
  rows: AccountStatementRow[];
  count: number;
  page: number;
  page_size: number;
  total_pages: number;
}

export interface AccountStatementFilters {
  fromDate?: Date;
  toDate?: Date;
  transactionType?: string;
  betStatus?: string;
  onlyLive?: boolean;
  /** When true, only ledger rows linked to a casino game (gaming history). */
  casinoOnly?: boolean;
}

export async function getAccountStatement(
  user: UserInfo,
  page: number,
  pageSize: number,
  filters?: AccountStatementFilters
): Promise<AccountStatementResponse | null> {
  const baseUrl = process.env.REACT_APP_GAME_API_BACKEND_API ?? '';
  const from = prepareDateTimeForHttpRequest(filters?.fromDate);
  const to = prepareDateTimeForHttpRequest(filters?.toDate);
  const tx = (filters?.transactionType ?? '').trim();

  const params = new URLSearchParams({
    player_id: String(user.id),
    page: String(page),
    page_size: String(pageSize),
  });
  if (from) params.set('from_time', from);
  if (to) params.set('to_time', to);
  if (tx && tx.toLowerCase() !== 'all') params.set('transaction_type', tx);
  const betStatus = (filters?.betStatus ?? '').trim().toLowerCase();
  if (betStatus && betStatus !== '0') params.set('bet_status', betStatus);
  if (filters?.onlyLive) params.set('only_live', 'true');
  if (filters?.casinoOnly) params.set('casino_only', 'true');

  try {
    const { data } = await axios.get<AccountStatementResponse>(
      `${baseUrl}/get_account_statement?${params.toString()}`
    );
    return data;
  } catch (e) {
    console.error(e);
    return null;
  }
}

export async function getTicketForPlayer(
  user: UserInfo,
  ticketId: number
): Promise<Slip | null> {
  const baseUrl = process.env.REACT_APP_GAME_API_BACKEND_API ?? '';
  try {
    const { data } = await axios.get(
      `${baseUrl}/get_ticket_for_player?player_id=${user.id}&ticket_id=${ticketId}`
    );
    const mapped = mapHttpResponse([data]);
    return mapped[0] ?? null;
  } catch (e) {
    console.error(e);
    return null;
  }
}
